import Grid from '@mui/material/Grid';
import type { FunctionComponent } from 'react';

import { ComponentErrorBoundary } from '../../../error-handling/ErrorBoundaries';
import { UserBackgroundHistoriesTitle } from '../../profile/common-section/common/UserBackgroundHistoriesTitle';
import { Certificates } from '../common-section/Certificates';
import { CourseHistory } from '../common-section/CourseHistory';
import { EducationHistory } from '../common-section/EducationHistory';
import { ProjectHistory } from '../common-section/ProjectHistory';
import { PublicationHistory } from '../common-section/PublicationHistory';
import { WorkHistory } from '../common-section/WorkHistory';

type UserHistoryProps = { readonly userId: string };

export const UserHistory: FunctionComponent<UserHistoryProps> = ({ userId }) => (
    <Grid container={true} flexDirection="column" gap={5}>
        <UserBackgroundHistoriesTitle />
        <ComponentErrorBoundary message="errors.component.profile.work-history">
            <WorkHistory userId={userId} />
        </ComponentErrorBoundary>
        <ComponentErrorBoundary message="errors.component.profile.education-history">
            <EducationHistory userId={userId} />
        </ComponentErrorBoundary>
        <ComponentErrorBoundary message="errors.component.profile.project-history">
            <ProjectHistory userId={userId} />
        </ComponentErrorBoundary>
        <ComponentErrorBoundary message="errors.component.profile.course-history">
            <CourseHistory userId={userId} />
        </ComponentErrorBoundary>
        <ComponentErrorBoundary message="errors.component.profile.certificates-history">
            <Certificates userId={userId} />
        </ComponentErrorBoundary>
        <ComponentErrorBoundary message="errors.component.profile.publication-history">
            <PublicationHistory userId={userId} />
        </ComponentErrorBoundary>
    </Grid>
);
